<div class="modal-header d-flex align-items-center px-3 w-100">
    <div class="d-flex align-items-center">
      <i
        *ngIf="counter > 0"
        class="icon-arrow-left mr-2 cursor-pointer"
        (click)="onPrevious()"
        role="button"
        tabindex="0"
        (keydown.enter)="onPrevious()"
        aria-label="Go back"
      ></i>
      <img
        class="mr-2"
        src="https://company.rubbl.com/pubweb/marketplace/images/logos/rubbl-logo-no-text.svg"
        alt="Rubbl"
        height="36"
        width="auto"
      />
      <a href="tel:(866) 455-8531" class="fs-17 text-dark text-decoration-none text-nowrap">(866) 455-8531</a>
    </div>
    <i
      class="icon-close text-grey ml-auto cursor-pointer"
      id="icon-close"
      role="button"
      tabindex="0"
      (click)="activeModal.dismiss(steps[counter].name)"
      (keydown.enter)="activeModal.dismiss(steps[counter].name)"
      aria-label="Close"
    ></i>
  </div>
  <div>
    <div *ngFor="let step of steps; index as i">
      <common-add-to-cart-dates
        *ngIf="step.name == 'startDate' && counter == i"
        [startDate]="startDate"
        [endDate]="endDate"
        [duration]="duration"
        [showDeliveryAddress]="!inCheckout"
        [showZipCode]="!inCheckout"
        [deliveryAddress]="deliveryAddress"
        [defaultMapLocation]="searchMapLocation"
        [invalidDeliveryAddress]="invalidDeliveryAddress"
        [deliveryOption]="deliveryOption"
        [rpoEnabled]="machine.rpoEnabled"
        [rateSchedules]="machine.rateSchedules"
        [machineId]="machine.id"
        [machineAccountId]="machine.accountId"
        [attachments]="machine.relatedAttachments"
        [attachmentsFromIndex]="attachmentsFromIndex"
        (startDateSelected)="startDateSelected($event)"
        (endDateSelected)="endDateSelected($event)"
        (durationSelected)="durationSelected($event)"
        (locationSelected)="locationSelected($event)"
        (deliveryOptionChange)="deliveryOptionSelected($event)"
      ></common-add-to-cart-dates>
      <ng-container *ngIf="step.name == 'addToCart' && counter == i">
        <common-add-to-cart-details
          *ngIf="!isDenied"
          [cartItem]="cartItem"
          [deliveryOption]="deliveryOption"
          [comingFromDateDurationStep]="true"
          (goToPreviousStep)="onPrevious()"
        ></common-add-to-cart-details>

        <div class="px-4 pb-3" *ngIf="!isDenied">
          <div class="bb-light mb-3"></div>
          <div *ngIf="appliedCouponCode" class="alert alert-success d-flex align-items-center py-2 px-3 mb-0">
            <i class="icon-checkmark mr-1"></i>
            <span class="font-weight-bold text-uppercase">{{ appliedCouponCode }}</span>
            <span class="ml-auto text-danger font-weight-bold cursor-pointer small" (click)="removeCoupon()">Remove</span>
          </div>
          <div class="d-flex align-items-center" *ngIf="!appliedCouponCode">
            <input
              type="text"
              class="form-control mr-2"
              placeholder="Enter coupon code"
              [(ngModel)]="couponCode"
              (keyup.enter)="applyCoupon()"
              [disabled]="couponLoading"
            />
            <button
              class="btn btn-outline-success text-nowrap"
              (click)="applyCoupon()"
              [disabled]="!couponCode?.trim() || couponLoading"
            >
              {{ couponLoading ? 'Applying...' : 'Apply' }}
            </button>
          </div>
          <small class="text-danger" *ngIf="couponError">{{ couponError }}</small>
        </div>

        <div class="m-2 alert alert-danger font-weight-light cursor-pointer d-flex align-items-center" role="alert" *ngIf="isDenied">
          <i class="icon-info mr-2"></i>
          <div>Your account is denied. If this is a mistake contact us at <a href="tel:(866) 455-8531">(866) 455-8531</a>.</div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="modal-footer modal-footer-desktop d-md-flex justify-content-center">
    <button class="book-by-phone btn btn-modal-footer h-100" (click)="activeModal.dismiss(steps[counter].name)">
      {{ steps[counter].cancelButtonText }}
    </button>
    <common-button-spinner
      class="h-100"
      buttonClass="add-to-cart btn btn-modal-footer btn-secondary h-100"
      [text]="steps[counter].buttonText"
      (clickChange)="steps[counter].buttonMethod()"
      [disabled]="steps[counter].buttonDisabled()"
      [loading]="loading"
      svgSpinnerHeight="26px"
    ></common-button-spinner>
  </div>

  <div class="mobile-footer d-flex d-md-none flex-column p-3">
    <common-button-spinner
      [buttonClass]="
        steps[counter].name == 'addToCart'
          ? 'add-to-cart btn btn-modal-footer btn-success w-100'
          : 'add-to-cart btn btn-modal-footer btn-secondary w-100'
      "
      [text]="steps[counter].buttonText"
      (clickChange)="steps[counter].buttonMethod()"
      [disabled]="steps[counter].buttonDisabled()"
      [loading]="loading"
      svgSpinnerHeight="26px"
    ></common-button-spinner>
    <button class="book-by-phone btn btn-modal-footer w-100 mt-2" (click)="activeModal.dismiss(steps[counter].name)">
      {{ steps[counter].cancelButtonText }}
    </button>
  </div>
